/* Groe — live page search
   ========================================================================
   Shopify's search index only reads a page's title and body, and every Groe
   page is built from theme sections with an empty body — so "Elizabeth",
   "tier" or "doctor" could never be found. Instead of copying section text
   into the body (which goes stale the moment the client edits a section),
   this reads the LIVE pages: it fetches each page linked from the header or
   footer, keeps the text inside <main>, and searches that. Whatever the
   client changes in the Theme Editor is searchable on the next visit.

   A page is searchable by being in a header/footer menu; nothing to maintain.
   The index is built once per session on the first search and cached.
   ===================================================================== */
(function () {
  'use strict';

  var CACHE_KEY = 'groe-page-index-v1';
  var TTL = 30 * 60 * 1000;
  var SKIP = ['/pages/growth-guide', '/pages/growth-guide-article'];
  var BLOCK = 'p,h1,h2,h3,h4,h5,h6,li,dt,dd,summary,blockquote,figcaption,td,th,div,section,article,label,button,.dl';
  var building = null;

  function pageUrls() {
    var seen = {};
    return Array.prototype.slice.call(document.querySelectorAll('a[href*="/pages/"]'))
      .filter(function (a) { return !a.closest('main'); })
      .map(function (a) { return new URL(a.getAttribute('href'), location.origin).pathname; })
      .filter(function (path) {
        if (seen[path] || SKIP.indexOf(path) > -1) return false;
        seen[path] = true;
        return true;
      });
  }

  /* textContent would glue "It started" + "with one kid" (one <span class="dl">
     per heading line) into "startedwith", so block edges get a space first. */
  function pageText(doc) {
    var main = doc.querySelector('main');
    if (!main) return '';
    main.querySelectorAll('script,style,noscript,template,svg,form,[aria-hidden="true"],.sr-only').forEach(function (el) { el.remove(); });
    main.querySelectorAll('br').forEach(function (br) { br.replaceWith(' '); });
    main.querySelectorAll(BLOCK).forEach(function (el) { el.append(' '); });
    return main.textContent.replace(/\s+/g, ' ').trim();
  }

  function fetchPage(path) {
    return fetch(path, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var title = (doc.title || path).split(' — ')[0].split(' – ')[0].trim();
        return { url: path, title: title, text: pageText(doc) };
      })
      .catch(function () { return null; });
  }

  function readCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY));
      if (c && Date.now() - c.at < TTL) return c.pages;
    } catch (e) {}
    return null;
  }

  function index() {
    var cached = readCache();
    if (cached) return Promise.resolve(cached);
    if (building) return building;
    building = Promise.all(pageUrls().map(fetchPage)).then(function (pages) {
      pages = pages.filter(Boolean);
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), pages: pages })); } catch (e) {}
      building = null;
      return pages;
    });
    return building;
  }

  function excerpt(text, at, len) {
    var start = Math.max(0, at - 60);
    if (start > 0) start = text.indexOf(' ', start) + 1;
    var out = text.slice(start, start + len);
    var cut = out.lastIndexOf(' ');
    if (start + len < text.length && cut > 0) out = out.slice(0, cut);
    return (start > 0 ? '… ' : '') + out + (start + len < text.length ? ' …' : '');
  }

  /* Every word of the query must appear in the page; title matches rank first. */
  function find(q) {
    var terms = String(q || '').toLowerCase().split(/\s+/).filter(function (t) { return t.length > 1; });
    if (!terms.length) return Promise.resolve([]);
    return index().then(function (pages) {
      return pages
        .map(function (p) {
          var hay = (p.title + ' ' + p.text).toLowerCase();
          if (!terms.every(function (t) { return hay.indexOf(t) > -1; })) return null;
          var inTitle = terms.some(function (t) { return p.title.toLowerCase().indexOf(t) > -1; });
          var at = p.text.toLowerCase().indexOf(terms[0]);
          return { url: p.url, title: p.title, excerpt: excerpt(p.text, Math.max(at, 0), 160), rank: inTitle ? 0 : 1 };
        })
        .filter(Boolean)
        .sort(function (a, b) { return a.rank - b.rank; });
    });
  }

  window.GroePageSearch = { find: find };
})();
